import styled from 'styled-components';
import {
  SharedButtonFontStyle,
  SharedMediaButtonMargin,
  DetailsContainerSharedStyle,
} from '../../../styles/sharedUIElemStyles';

export const DetailsContainer = styled('div')`
  display: flex;
  flex-direction: column-reverse;
  ${DetailsContainerSharedStyle};
  > .ant-table-wrapper {
      width: 100%;
  }
  @media(max-width: 1024px) {
    padding: 10px;
  }
  @media (max-width: 576px) {
    padding: 10px;
  }
`;

export const ButtonContainer = styled('div')`
  display: flex;
  align-content: flex-start;
  button {
    ${SharedButtonFontStyle};
  }
  @media(max-width: 1024px) {
    padding-top: 15px;
  }
  @media (max-width: 992px) {
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;
    button {
      ${SharedMediaButtonMargin};
    }
  }
  @media (max-width: 668px), (max-height: 412px) {
    button {
    }
  }
  @media (max-width: 576px) {
    flex-wrap: wrap;
    padding: 0 20px;
    button {
      margin: 10px 15px 15px 0;
    }
  }
`;